import AppModal from '@/components/AppModal/AppModal';
import BoldSmallText from '@/components/BoldSmallText';
import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { IMAGE } from '@/helpers/link';
import { emailSettingSelector } from '@/redux/slice/email.slice';
import { BlockStack } from '@shopify/polaris';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PolarisModalScopedStyle } from '../../styled';

interface Props {
  open: boolean;
  onCancel: () => void;
}

export const EmailVerifiedModal = ({ open, onCancel }: Props) => {
  const emailSettings = useSelector(emailSettingSelector);

  useEffect(() => {
    if (open) {
      const modalElement = document.querySelector('.Polaris-Modal-Dialog__Modal');
      if (modalElement) {
        modalElement.classList.add('modal--email-verified');
      }
    } else {
      document.body.classList.remove('modal--email-verified');
    }

    return () => {
      document.body.classList.remove('modal--email-verified');
    };
  }, [open]);

  return (
    <>
      <PolarisModalScopedStyle />
      <AppModal open={open} onCancel={onCancel} onSubmit={() => {}} title={''}>
        <BlockStack inlineAlign="center" gap={'300'}>
          <img src={IMAGE.VERIFIED_EMAIL_IMG} alt="" />
          <BoldText alignment="center" variant="headingLg">
            Please verify your email
          </BoldText>
          <BlockStack>
            <RegularText alignment="center" variant="bodySm">
              You’re almost there! We sent an email to
            </RegularText>
            <BoldText alignment="center">{emailSettings.sender}</BoldText>
          </BlockStack>
          <RegularText alignment="center" variant="bodySm">
            Just click on the link that email to complete your connection. If you don’t see it, you may need to{' '}
            <BoldText as="span">check your spam</BoldText> folder.
          </RegularText>
        </BlockStack>
      </AppModal>
    </>
  );
};
